import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('.attachment--preview img').forEach((item) => {
      item.classList.add('lightbox-image');
      item.addEventListener('click', this.#open);
    });

    this.overlay = document.createElement('div');

    this.overlay.classList.add('lightbox-overlay', 'hidden');
    this.overlay.addEventListener('click', this.#close);

    this.image = document.createElement('img');

    this.image.classList.add('lightbox-overlay__image');

    this.overlay.appendChild(this.image);

    document.body.appendChild(this.overlay);
    document.addEventListener('keydown', this.#onKeydown);
  }

  disconnect() {
    this.overlay.remove();

    document.removeEventListener('keydown', this.#onKeydown);
  }

  #close = () => this.overlay.classList.add('hidden');

  #onKeydown = (event) => {
    if (event.key === 'Escape') this.#close();
  };

  #open = (event) => {
    this.image.src = event.currentTarget.dataset.originalSrc || event.currentTarget.src;

    this.overlay.classList.remove('hidden');
  };
}
